import { Button } from '@planuze/ui';
import { useNotificationsContent } from '../../content/sections/notifications.js';
import { BulkSelectionBar } from '../bulk-selection-bar.js';

export function NotificationBulkBar({
  selectedCount,
  busy,
  onDelete,
  onClear,
}: {
  readonly selectedCount: number;
  readonly busy: boolean;
  readonly onDelete: () => void;
  readonly onClear: () => void;
}) {
  const copy = useNotificationsContent();
  if (selectedCount === 0) return null;
  return (
    <BulkSelectionBar
      selectedLabel={copy.bulkSelected(selectedCount)}
      clearLabel={copy.bulkClear}
      busy={busy}
      onClear={onClear}
    >
      <Button size="sm" variant="destructive" disabled={busy} onClick={onDelete}>
        {copy.bulkDelete}
      </Button>
    </BulkSelectionBar>
  );
}
